import { render } from "./MpidDetailsInfo.vue?vue&type=template&id=fbf8fbe6&scoped=true"
import script from "./MpidDetailsInfo.vue?vue&type=script&lang=js"
export * from "./MpidDetailsInfo.vue?vue&type=script&lang=js"

import "./MpidDetailsInfo.vue?vue&type=style&index=0&id=fbf8fbe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbf8fbe6"]])

export default __exports__